module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-up-right-c28bd5d0.svg";